module.exports = __webpack_public_path__ + "img/3_15.3607bce1.png";